import React, { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { CDN_ORIGIN_ENDPOINT } from '../../../../../shared/cdn';
import favicon from '../../assets/img/favicon_32.png';
import { BreadcrumbJsonLd } from './BreadcrumbJsonLd';
import { GoogleAdwords } from './GoogleAdwords';
import { HeadBrowserConfig } from './HeadBrowserConfig';
import { WEBSITE_URL } from './headConstants';
import { HeadFavicon } from './HeadFavicon';
import { HeadGoogleMarkup } from './HeadGoogleMarkup';
import { HeadGoogleTagManager } from './HeadGoogleTagManager';
import { headIntercom } from './headIntercom';
import { headIsScriptError } from './headIsScriptError';
import { HeadOpenGraph } from './HeadOpenGraph';
import { HeadRobotSeo } from './HeadRobotSeo';
import { headRollbar } from './headRollbar';
import { HeadSocial } from './HeadSocial';
import { printDoctrineToConsole } from './printDoctrineToConsole';

type Props = {
  title?: string;
  url: string;
  description?: string;
  breadcrumbs?: Array<{ url: string; current: boolean; label: string }>;
};

export const BaseHead: FC<Props> = ({
  title,
  url,
  description,
  breadcrumbs,
}) => {
  const completeUrl = `${WEBSITE_URL}${url}`;
  useEffect(() => {
    const loadScripts = async () => {
      await headRollbar();
      headIsScriptError();
      await headIntercom();
      printDoctrineToConsole();
    };
    loadScripts();
  }, []);
  return (
    <>
      <Helmet>
        <html lang="fr" />
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="icon" type="image/png" href={favicon} sizes="32x32" />
        <link
          rel="preconnect"
          href={CDN_ORIGIN_ENDPOINT}
          crossOrigin="anonymous"
        ></link>
        <link rel="manifest" href="/manifest.json" />
      </Helmet>
      <HeadBrowserConfig />
      <HeadSocial title={title} description={description} />
      <HeadOpenGraph
        title={title}
        url={completeUrl}
        description={description}
      />
      <HeadRobotSeo url={completeUrl} />
      <HeadFavicon />
      <HeadGoogleMarkup url={url} />
      <HeadGoogleTagManager />
      <GoogleAdwords />
      {breadcrumbs && <BreadcrumbJsonLd breadcrumbs={breadcrumbs} />}
    </>
  );
};
